import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Handles Google Tag Manager data layer.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * event - (required) - event to send to data layer
 *
 * Usage
 * -------
 *
 * <div data-controller="gtm-data-layer" data-action="click->gtm-data-layer#sendEvent" data-gtm-data-layer-event-value='{ "event": "test" }'>
 * </div>
 */
export default class default_1 extends Controller {
    static values = {
        event: { type: String },
    };
    sendEvent() {
        const event = JSON.parse(this.eventValue);
        window.dataLayer.push(event);
    }
}
